<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <section v-else>
      <img class="img" src="/static/images/Normal21/img-01.png" />
      <div class="box">

        <div class="title bold blue-title mt20 ml50">
          <p>{{datas.product.name}}</p>
          <p>{{datas.product.introduce || '销售有限公司欢迎您'}}</p>
        </div>

        <div class="red-title mt30 ml60">
          <p>购买烟花看证照</p>
          <p>流动摊贩无保障</p>
        </div>

        <div class="title blue-text mt30 ml30">
          <p  v-for="(val, index) in datas.product.attribute" :key="index">
            <span>{{ val.key }}</span>
            <span>{{ val.value }}</span>
          </p>
        </div>

        <div class="title bold red-title mt30">企业简介</div>

        <div class="blue-text main-text mt30">
          <p>{{datas.product.name}}销售有限公司恪守“诚信至上，服务第一”的理念，坚持以上乘的品质、优质的服务回馈客户。真诚希望与社会各界朋友合作，为开创烟花爆竹安全经营管理的全新局面努力奋斗，共同走向灿烂的明天！</p>
          <p class="mt20">因为有我，夜空更加璀璨！</p>
          <p>因为有你，生活更加精彩！</p>
          <p class="mt20">公司宗旨：安全第一、质量第一、服务第一、信誉第一。</p>
          <p>公司发展方向和目标：严格管理、确保安全、规范运作、规模经营、持续发展。</p>
        </div>


        <template v-if="datas.ref && datas.ref_is_show == 1">
          <div class="ref-title">烟花展示</div>
          <div class="ref-box" v-for="(item, index) in datas.ref" v-bind:key="index">
            <div class="title" v-text="item.name"></div>
            <ul>
              <li v-for="(val, ix) in item.datas" v-bind:key="ix">
                <p class="text" v-if="val.type == 0" v-text="val.data"></p>
                <img v-else :src="val.data">
              </li>
            </ul>
          </div>
        </template>
        
        
        <div class="title bold red-title mt30">安全燃放</div>

        <div class="mt20">
          <img class="img" src="/static/images/Normal21/img-02.png" />
          <img class="img mt10" src="/static/images/Normal21/img-03.png" />
        </div>

      </div>
    </section>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal21',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      msg: '',
      datas: null,
      hintTxt: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      }
    }
  },
  created() {
    self = this;
    document.body.style.backgroundColor = "rgb(255, 255, 255)";

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    }
  }
}
</script>

<style scoped lang="scss">
$margin: top, right, bottom, left;
@each $i in $margin {
  @for $j from 1 through 100 {
    $key: str-slice($i, 1, 1);

    .m#{$key}#{$j} {
      margin-#{$i}: $j + px !important;
    }
  }
}

.img{
  width: 100%;
  display: block;
}
.box{
  padding: 20px;
}
.title{
  font-size: 18px;
}
.bold{
  font-weight: bold;
}
.blue-title{
  color: rgb(0, 176, 240);
}
.blue-text{
  color: rgb(0, 112, 192);
}
.red-title{
  color: rgb(255, 0, 0);
}
.main-text p{
  text-indent: 2em;
  line-height: 23px;
}

.ref-title{
  color: rgb(255, 0, 0);
  font-size: 28px;
  font-weight: bold;
  margin-top: 40px;
}
.ref-box{
  .title{
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    color: rgb(0, 176, 80);
  }
  img{
    width: 100%;
    display: block;
    margin-top: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/Normal21.vue